import { Tube } from '@App/app/entities/layer/tube.model';
import { Component } from '@angular/core';
import { BaseLayerPropertiesComponent } from '../base-layer-properties/base-layer-properties.component';

@Component({
  selector: 'app-tube-properties',
  templateUrl: './tube-properties.component.html',
})
export class TubePropertiesComponent extends BaseLayerPropertiesComponent<Tube> {}
